import Cookies from './service'
import * as LatestProjectName from '~/cookieServices/LatestProjectName'
import * as API from '~/ServerAPI'
import * as LatestProjectId from './LatestProjectId'
import { defaultCookiesParamsMaxTime } from './defaultCookiesParams'

const cookies = Cookies.getInstance()
const AUTH_TOKEN = 'authToken'

export function set(authToken) {
  if (cookies.get(AUTH_TOKEN) !== authToken) {
    LatestProjectId.set('')
    LatestProjectName.set('')
  }
  cookies.set(AUTH_TOKEN, authToken, defaultCookiesParamsMaxTime)
  API.setAuthToken(authToken)
}

export function get() {
  return cookies.get(AUTH_TOKEN)
}

export function removeAllCookies() {
  const allCookies = cookies.getAll()
  Object.keys(allCookies).forEach(cookieName => {
    cookies.remove(cookieName, { path: '/' })
  })
}
